import { ref, set, get, remove } from "firebase/database";
import { database } from "services/firebaseService/firebaseConfig";
import { getRandomString } from "../getRandomString";

export const ACCESS_CHECK_PATH = "NewAccessCheck";

export const checkFirebaseAccess = async (): Promise<boolean> => {
  const random = getRandomString();
  const time = Date.now();

  await set(ref(database, `${ACCESS_CHECK_PATH}/${random}`), { time });

  const readResult = await get(ref(database, `${ACCESS_CHECK_PATH}/${random}`));

  const timesMatch = readResult.val()?.time === time;

  await remove(ref(database, `${ACCESS_CHECK_PATH}/${random}`));

  return timesMatch;
};
